/**
 * Телефон у тому вигляді, в якому він лежить у базі.
 *
 * Бек шукає користувача під час входу за **точним** значенням `phone`
 * (`Core/Security/ApiAuthenticator`), а номери в базі нормалізовані: лише
 * цифри, провідний `0` замінено на `380` (Ship `ContactDataNormalizer`, той
 * самий алгоритм, що в легасі `FormattingUtil::phoneNumber`). Тож
 * «+38 (099) 123-45-06» без нормалізації просто не знайдеться.
 *
 * Алгоритм навмисно не розумніший за беківський: будь-яке «вгадування» тут
 * розійшлося б із тим, що записано в базі, і вхід мовчки перестав би
 * знаходити людину.
 */
export const normalizePhone = (value: string): string => {
    const digits = value.replace(/\D/g, '')

    return digits.startsWith('0') ? `380${digits.slice(1)}` : digits
}
